import { Box, Button, CircularProgress, TextField } from "@mui/material";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { useState } from "react";
import * as Yup from "yup";
import { MessageText } from "../../constants/messageText";
import instance from "../../utils/axiosInstance";
import { CreateOrUpdateTeam } from "../../constants/api-urlConstants";
import { SnackBarMessage } from "../snackBar/snackBar";

interface CreateTeamProps {
  onCancel?: () => void;
  fetchAndClose?: () => void;
}

const CreateTeam = (props: CreateTeamProps) => {
  
  const { onCancel, fetchAndClose } = props;
  const [initial_state, setInitial_state] = useState<any>({ name: "" });
  const [isLoading, setIsLoading] = useState(false);
  const [msgConfig, setMsgConfig] = useState({
    type: "",
    message: "",
    snackFlag: false,
  });

  const TeamCreationFormValidation = Yup.object().shape({
    name: Yup.string()
      .min(2, MessageText.VALIDATION_MIN_2)
      .trim(MessageText.VALIDATION_TEAM_NAME_REQUIRED)
      .required(MessageText.VALIDATION_TEAM_NAME_REQUIRED)
  })

  const onFinish = (data: {name: string}) => {
    setIsLoading(true);
    const payload = { name: data.name };
    const apiURL = `${CreateOrUpdateTeam}`;
    instance.post(apiURL, payload).then(res => {
      setMsgConfig({
        type: "success",
        message: MessageText.TEAM_CREATED_SUCCESSFULLY,
        snackFlag: true,
      });
      setTimeout(() => {
        fetchAndClose?.();
      }, 2000);
    })
    .catch(() => {
      setMsgConfig({
        type: "error",
        message: MessageText.CREATE_TEAM_FAILED,
        snackFlag: true,
      });
    })
    .finally(() => { setIsLoading(false); })
  }

  return (
    <Box sx={{px:2}}>
      <Formik
        enableReinitialize={true}
        initialValues={initial_state}
        validationSchema={TeamCreationFormValidation}
        onSubmit={onFinish}
      >
        {({ touched, errors, handleSubmit }) => (
          <Form onSubmit={handleSubmit}>
            <Field
              as={TextField}
              margin="normal"
              error={touched.name && Boolean(errors.name)}
              fullWidth
              label="Team Name*"
              name="name"
              size="small"
              InputLabelProps={{ shrink: true }}
              helperText={<ErrorMessage name="name" />}
            />
              {isLoading ?
                <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 2, py: 1}}>
                  <div className="progressCircle">
                    <CircularProgress size={28} />
                  </div>
                </Box>
                :
                <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 2, py: 1}}>
                  <Button
                    type="button"
                    variant="outlined"
                    className="submitBtn"
                    style={{ textTransform: "none" }}
                    onClick={onCancel}
                  >
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    variant="contained"
                    className="submitBtn"
                    style={{ textTransform: "none" }}
                  >
                    Create
                  </Button>
                </Box>
              }
          </Form>
        )}

      </Formik>
      {msgConfig.snackFlag && (
        <div>
          <SnackBarMessage snacBarValue={msgConfig} />
        </div>
      )}
    </Box>
  );
}

export default CreateTeam;
